import { DATE_FACET_ATTRIBUTE_ID } from './date-facet';
import { PRICE_FACET_ATTRIBUTE_ID } from './price-facet';
import { VENUE_FACET_ATTRIBUTE_ID } from './venue-facet';

/**
 * Attribute refinements always promoted out of the Filtri drawer onto the sticky bar.
 * Always exclude these from drawer lists and Filtra badge counts.
 */
export const PROMOTED_REFINEMENT_ATTRIBUTE_IDS = [DATE_FACET_ATTRIBUTE_ID, VENUE_FACET_ATTRIBUTE_ID] as const;

/**
 * Refinement attribute ids to hide from the Filtri drawer / badge.
 * When `promotePrice` is true (events/courses listings), also excludes `price`.
 */
export function getExcludedRefinementAttributeIds(options?: { promotePrice?: boolean }): readonly string[] {
    if (options?.promotePrice) {
        return [...PROMOTED_REFINEMENT_ATTRIBUTE_IDS, PRICE_FACET_ATTRIBUTE_ID];
    }
    return PROMOTED_REFINEMENT_ATTRIBUTE_IDS;
}
